import { render, staticRenderFns } from "./blockTimeAlert.vue?vue&type=template&id=59b46fc3"
import script from "./blockTimeAlert.vue?vue&type=script&lang=js"
export * from "./blockTimeAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports